import React from 'react';
import { MODALS } from '../../../../../config/images';
const ModalAlert = ({ showModalAlert, warningMessage, textWarning, closeModal, accept, title, description, excelData }) => {
  if (!showModalAlert) return null;

  const handleDownloadExcel = () => {
    if (!excelData) {
      closeModal();
      return;
    }

    try {
      const binaryString = window.atob(excelData);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      const blob = new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Evaluaciones_con_errores.xlsx');
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      
    } catch (error) {
      console.error('Error al descargar el archivo:', error);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center w-full bg-black bg-opacity-50">
      <div className="lg:w-[24.33%] sm:w-[60%] w-[85%] h-auto bg-white rounded-3xl shadow-lg flex flex-col pb-4">
        <div className='flex justify-end'>
          <button
            onClick={closeModal}
            className="px-4 py-2 rounded-md"
          >
            <img src={MODALS.CLOSE} alt="cerrar"/>
          </button>
        </div>
        <div className='flex flex-col items-center justify-center gap-3 p-4 px-8'>
            <img src={MODALS.WARNING} alt="warning"/>
            <div className='flex flex-col gap-4'>
              <p className="text-sm text-center font-itcdemi">
                {title}
              </p>
              <div className="text-sm text-justify whitespace-pre-line font-itcbook">
                {description}
              </div>

              {excelData && (
              <button
                onClick={handleDownloadExcel}
                className='font-itcbook text-[16px] underline text-blue'>
                Descargar
              </button>
              )}

              {warningMessage && (
                <p className='font-itcbold text-center text-[14px] '>{warningMessage}</p>
              )}

            </div>
        </div>
      </div>
    </div>
  );
};

export default ModalAlert;